import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCamera4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCamera4"><Path d="M4.75 4.5H2.5V19.5H21.5V4.5H9.25L8.25 3.5H5.75L4.75 4.5Z" stroke="currentColor"/><Path d="M17.5 12C17.5 13.933 15.933 15.5 14 15.5C12.067 15.5 10.5 13.933 10.5 12C10.5 10.067 12.067 8.5 14 8.5C15.933 8.5 17.5 10.067 17.5 12Z" stroke="currentColor" strokeLinejoin="round"/><Path d="M7.5 9C7.5 9.27614 7.27614 9.5 7 9.5C6.72386 9.5 6.5 9.27614 6.5 9C6.5 8.72386 6.72386 8.5 7 8.5C7.27614 8.5 7.5 8.72386 7.5 9Z" stroke="currentColor" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconCamera4;
